const { registerPlugin } = wp.plugins;
const { PluginDocumentSettingPanel } = wp.editPost;
const { CheckboxControl, ToggleControl } = wp.components;
const { useDispatch, useSelect, select } = wp.data;

const SchemaOptionInDocumentPanel = () => {
	const schemaOption = useSelect(function () {
		return select('core/editor').getEditedPostAttribute(
			'meta'
		).wpgo_faq_disable_schema;
	}, []);

	const editPost = useDispatch('core/editor').editPost;
	const postType = select('core/editor').getCurrentPostType();

	if (!('page' === postType || 'post' === postType)) {
		return <></>;
	}

	//console.log("STATUS", schemaOption);
	return (
		<PluginDocumentSettingPanel
			name="schema-settings"
			title="FAQ Schema Settings"
			className="wpgo-schema-settings"
		>
			<ToggleControl
				label="Enable FAQ schema?"
				help={`Toggle FAQ schema output for this ${postType} only.`}
				checked={schemaOption}
				onChange={(val) => {
					editPost({
						meta: {
							wpgo_faq_disable_schema: val,
						},
					});
				}}
			/>
			{/* <p style={{marginTop:'20px'}}><button type="button" className="button button-secondary"><a style={{textDecoration:'none'}} href={faqSchemaPreviewURI} target="_blank">Validate Schema &amp; Preview</a></button></p> */}
		</PluginDocumentSettingPanel>
	);
};

registerPlugin('plugin-sidebar-test', {
	render: SchemaOptionInDocumentPanel,
	icon: null,
});
